import { Component } from 'vue-property-decorator';
import Base from '@/components/Base';
import { ConnectCard, feSdk } from '@streamlabs-core/sl-one-fe-components-vue2';
import { EAnalyticsEvent } from '@/helpers/analytic';

@Component({
  components: {
    ConnectCard
  },
})
export default class SLConnectForm extends Base {
  intent = 'connect';

  onRedirectRequested(to: string) {
    if (to === 'login') {
      this.logoutUserFromSLID();
      this.$router.push('/login');
    }

    if (to === 'email')
      this.$router.push('/verify-email');

    if (to === 'tfa')
      this.$router.push('/verify-tfa');
  }

  handleVerificationRequired(type) {
    switch (type) {
      case 'email':
        this.onRedirectRequested('email');
        break;

      case 'tfa':
        this.onRedirectRequested('tfa');
        break;

      case 'age-gate':
        //this.onRedirectRequested('age-gate');
        break;

      default:
        break;
    }
  }

  onError(data) {
    this.$sla.sendEvent(EAnalyticsEvent.slNativeLoginFailure, { error: data });
  }

  onCancel() {
    this.logoutUserFromSLID();
    this.$router.push('/login');
  }

  async logoutUserFromSLID() {
    try {
      await feSdk.api.auth.logout();
    } catch {
      // already logged out
    }

    this.slidModule.setSLIDSession(null);
  }
}


